export default "__VITE_ASSET__cJKI5WZG__"